// Currency formatting utilities

const currencySymbols = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  CAD: 'CA$',
  AUD: 'A$',
  JPY: '¥',
  CHF: 'CHF',
  CNY: '¥',
  INR: '₹',
  MXN: 'MX$',
};

/**
 * Get currency symbol for a currency code
 * @param {string} currency - Currency code (e.g., 'USD', 'EUR')
 * @returns {string} Currency symbol
 */
export const getCurrencySymbol = (currency) => {
  if (!currency) return '$'; // Default to USD
  return currencySymbols[currency.toUpperCase()] || currency + ' ';
};

/**
 * Format an amount with currency symbol
 * @param {number} amount - Amount to format
 * @param {string} currency - Currency code (e.g., 'USD', 'EUR')
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {string} Formatted amount with currency symbol
 */
export const formatCurrency = (amount, currency = 'USD', decimals = 2) => {
  const symbol = getCurrencySymbol(currency);
  const formattedAmount = Number(amount).toFixed(decimals);

  // For currencies that use symbol after amount
  const symbolAfter = [];
  if (symbolAfter.includes(currency?.toUpperCase())) {
    return `${formattedAmount}${symbol}`;
  }

  // Default: symbol before amount
  return `${symbol}${formattedAmount}`;
};
